export default __webpack_public_path__ + "static/media/LogoBlou.10020530.png";